import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>© Citizens of the Internet 2025 • Built with React and dad stamina</p>
    </footer>
  );
};

export default Footer;